(function () {
  if (typeof window === 'undefined') return;

  function setup(section) {
    var pills = Array.prototype.slice.call(section.querySelectorAll('[data-mm-cfv2-pill]'));
    var chip = section.querySelector('[data-mm-cfv2-chip]');
    var chipLabel = section.querySelector('[data-mm-cfv2-chip-label]');
    var chipRemove = section.querySelector('[data-mm-cfv2-chip-remove]');
    var subjectInput = section.querySelector('[data-mm-cfv2-subject-input]');
    if (!pills.length) return;

    function selectPill(pill) {
      pills.forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-selected', 'false');
      });
      pill.classList.add('is-active');
      pill.setAttribute('aria-selected', 'true');

      var label = pill.dataset.topicLabel || '';
      if (chipLabel) chipLabel.textContent = label;
      if (subjectInput) subjectInput.value = label;
      if (chip) chip.hidden = false;
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        selectPill(pill);
      });
    });

    if (chipRemove) {
      chipRemove.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-selected', 'false');
        });
        if (subjectInput) subjectInput.value = '';
        if (chip) chip.hidden = true;
        var pillsWrap = section.querySelector('.mm-contact-form-v2__pills');
        if (pillsWrap && pillsWrap.scrollIntoView) {
          pillsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  }

  function init() {
    var sections = document.querySelectorAll('[data-mm-contact-form-v2]');
    sections.forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
